<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <div class="card-header bg-transparent pb-5">
          <div class="btn-wrapper text-center mt-3">
            <!-- <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                            <span class="btn-inner--text">Github</span>
                        </a> -->
            <a
              href="#"
              class="btn btn-neutral btn-icon"
              style="color: #525f7f"
              @click="login"
            >
              <span class="btn-inner--icon"
                ><img src="img/icons/common/google.svg"
              /></span>
              <span class="btn-inner--text">Entrar con Google</span>
            </a>
          </div>
          <div class="text-muted text-center mt-3" style="font-size: 14px">
            <small
              >Para entrar asegurate de utilizar tu cuenta de canplast.com.mx,
              cuentas personales no podrán acceder.</small
            >
          </div>
        </div>
        <!-- <div class="card-body px-lg-5 py-lg-5">
                    <div class="text-center text-muted mb-4">
                        <small>Or sign in with credentials</small>
                    </div>
                    <form role="form">
                        <base-input class="input-group-alternative mb-3"
                                    placeholder="Email"
                                    addon-left-icon="ni ni-email-83"
                                    v-model="model.email">
                        </base-input>

                        <base-input class="input-group-alternative"
                                    placeholder="Password"
                                    type="password"
                                    addon-left-icon="ni ni-lock-circle-open"
                                    v-model="model.password">
                        </base-input>

                        <base-checkbox class="custom-control-alternative">
                            <span class="text-muted">Remember me</span>
                        </base-checkbox>
                        <div class="text-center">
                            <base-button type="primary" class="my-4">Sign in</base-button>
                        </div>
                    </form>
                </div> -->
      </div>
      <!-- <div class="row mt-3">
                <div class="col-6">
                    <a href="#" class="text-light"><small>Forgot password?</small></a>
                </div>
                <div class="col-6 text-right">
                    <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
                </div>
            </div> -->
    </div>
  </div>
</template>
<script>
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

export default {
  name: "login",
  data() {
    return {
      model: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    login() {
      const provider = new GoogleAuthProvider();
      const auth = getAuth();

      signInWithPopup(auth, provider)
        .then((result) => {
          if (result.user.email.slice(-16) === "@canplast.com.mx" || result.user.email === "lectorcodigos.cpm@gmail.com") {
            this.$router.replace("inicio");
          } else {
            signOut(auth).then(() => {
              alert("Solo las cuentas de @canplast.com.mx pueden acceder");
            });
          }
        })
        .catch((err) => {
          alert("Oops " + err.message);
        });
    },
  },
};
</script>
<style>
</style>
